/**
 * Default chart color palette — matches the existing Vega palette from chart-specs.ts
 * but extended with additional colors for variety.
 */
export const DEFAULT_CHART_COLORS = [
  '#0e7490', // teal
  '#6e44c1', // purple
  '#77bcc0', // light teal
  '#48276c', // dark purple
  '#998ce3', // light purple
  '#2563eb', // blue
  '#dc2626', // red
  '#059669', // green
  '#d97706', // orange
  '#7c2d12', // brown
];

/**
 * Detect if dark mode is currently active via the document root element.
 */
export function isDarkMode(): boolean {
  if (typeof document === 'undefined') return false;
  return document.documentElement.classList.contains('dark');
}

/**
 * Theme-aware color configuration for chart axes, grid lines, and text.
 */
export function getThemeColors() {
  const dark = isDarkMode();
  return {
    text: dark ? '#f9fafb' : '#1f2937',
    textMuted: dark ? '#9ca3af' : '#6b7280',
    grid: dark ? '#374151' : '#e5e7eb',
    axis: dark ? '#6b7280' : '#9ca3af',
    background: 'transparent',
    tooltipBg: dark ? '#1f2937' : '#ffffff',
    tooltipText: dark ? '#f9fafb' : '#1f2937',
    tooltipBorder: dark ? '#374151' : '#e5e7eb',
  };
}
